import React from "react";


const Contact = () => {
  return (
    <div className="contact-page">
      {/* Breadcrumb Section */}
      <section className="breadcrumb-area" style={{ backgroundImage: `url("assets/img/bg/bdrc-bg.png")` }}>
        <div className="container">
          <div className="breadcrumb-content">
            <h2 className="breadcrumb-title">Contact Us</h2>
            <nav className="breadcrumb-nav">
              <ul>
                <li><a href="/qeducato">Home</a></li>
                <li className="current">Contact Us</li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-area">
        <div className="container">
          <div className="section-header text-center">
            <h5 className="section-subtitle">Contact Info</h5>
            <h2 className="section-title">Get In Touch</h2>
          </div>
          <div className="contact-info-cards">
            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fa-solid fa-phone"></i>
              </div>
              <div className="contact-content">
                <h5><a href="tel:+14440008888">+91-9812151923/9992771695</a></h5>
                <p>Phone Support</p>
              </div>
            </div>
            <div className="contact-info-card active">
              <div className="contact-icon">
                <i className="fa-solid fa-envelope"></i>
              </div>
              <div className="contact-content">
                <h5><a href="mailto:resonancekaithal@gmail.com">ramaeducationtrust1@rediffmail.com</a></h5>
                <p>Email Address</p>
              </div>
            </div>
            <div className="contact-info-card">
              <div className="contact-icon">
                <i className="fa-regular fa-address-book"></i>
              </div>
              <div className="contact-content">
                <h5>VPO Kutabpur, Kaithal (Haryana)</h5>
                <p>Office Address</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-area">
        <div className="container">
          <div className="form-header text-center">
            <h2>Custom Inquiry Form</h2>
          </div>
          <form className="contact-form">
            <div className="form-grid">
              <div className="form-group">
                <input type="text" id="firstn" name="firstn" placeholder="First Name" />
                <i className="icon fa fa-user"></i>
              </div>
              <div className="form-group">
                <input type="email" id="email" name="email" placeholder="Email" />
                <i className="icon fa fa-envelope"></i>
              </div>
              <div className="form-group">
                <input type="text" id="phone" name="phone" placeholder="Phone No." />
                <i className="icon fa fa-phone"></i>
              </div>
              <div className="form-group full-width">
                <textarea name="message" id="message" rows="5" placeholder="Write comments"></textarea>
                <i className="icon fa fa-edit"></i>
              </div>
            </div>
            <div className="form-submit">
              <button type="submit" className="custom-btn">
                Make A Request <i className="fa fa-long-arrow-right"></i>
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
